/* @flow */
import { toIdValue } from 'apollo-utilities';
import { dataIdFromObject } from '../memory';

export const chatStreams = (_: *, args: *): string | void => {
  if (args.chatUuids) {
    return args.chatUuids.map(uuid => {
      const dataId = dataIdFromObject({ __typename: 'ChatStream', uuid });
      return dataId ? toIdValue(dataId) : undefined;
    });
  }

  return undefined;
};
